import EsteticPrice from '../../../entities/Price/EsteticPrice/ui/EsteticPrice';
import Hygiene from '../../../entities/Hygiene/ui/Hygiene';
import Whitening from '../../../entities/Whitening/ui/Whitening';
import Footer from '../../../widgets/Footer/ui/FooterContact/Footer';
import FooterInfo from '../../../widgets/Footer/ui/FooterInfo/FooterInfo';
import HeaderEstetic from '../../../widgets/HeaderEstetic/ui/HeaderEstetic';
import styles from './HygienePage.module.scss';


export const HygienePage = () => {
    return(
        <div className={styles.hygiene}>
         <HeaderEstetic/>
         <Hygiene/>
         <EsteticPrice/>
         <Whitening/>
         <Footer/> 
         <FooterInfo/> 
        </div>
    )
}